import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from './Button';
import ButtonSwitch from './ButtonSwitch';
import Since from '../Shared/Since';

const ActionButtons = props => {
    const css = {
        display: 'flex',
        textAlign: 'right',
        alignItems: 'center',
        '& .MuiButton-root': { ml: 1 }
    }
    return (
        <Grid item className="ButtonRow">
            <Grid container sx={{alignItems: 'center'}}>
            {props.updated && <Grid item xs ><Since lastUpdated={props.updated} /></Grid>}
            {props.enable  && <ButtonSwitch type="enable" handler={props.enable} status={props.enabled} />}
            {props.delete  && !props.createNew && <Button type="delete" handler={props.delete} />}
            {props.run     && <Button type="run" handler={props.run} color="secondary" />}
            {props.query   && <Button type="query" handler={props.query} color="secondary" />}
            {props.test    && <Button type="test" handler={props.test} />}
            {props.refresh && <Button type="refresh" handler={props.refresh} label={props.labels?.refresh} />}
            {props.new     && <Button type="new" handler={props.new} color="success" />}
            {props.save    && <Button type="save" handler={props.save} createNew={props.createNew} label={props.labels?.save} />}
            </Grid>
        </Grid>
    )
}
export default ActionButtons;